import { render, staticRenderFns } from "./failed-history.vue?vue&type=template&id=581183c6&scoped=true"
import script from "./failed-history.vue?vue&type=script&lang=js"
export * from "./failed-history.vue?vue&type=script&lang=js"
import style0 from "./failed-history.vue?vue&type=style&index=0&id=581183c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581183c6",
  null
  
)

export default component.exports